import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "c-float-action-widget"
}
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["rel", "aria-label"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["href", "target", "rel", "aria-label"]
const _hoisted_7 = ["innerHTML"]

import { computed, onMounted } from 'vue';
import type {
  FloatActionWidgetActionFields,
  FloatActionWidgetProps,
} from '@/types/components/FloatActionWidget';
import type { ScItem } from '@/types/sitecore';


export default /*@__PURE__*/_defineComponent({
  __name: 'FloatActionWidget',
  props: {
    fields: {}
  },
  setup(__props: any) {

const props = __props;

const actions = computed(() => props.fields?.actions ?? []);
const defaultVariants = ['light', 'green', 'light'];

const getFieldValue = (action: ScItem<FloatActionWidgetActionFields>, fieldName: string) => {
  if (action.fields == null) return undefined;
  const field = action.fields[fieldName as keyof FloatActionWidgetActionFields];
  return field?.value;
};

const getIconField = (action: ScItem<FloatActionWidgetActionFields>) => {
  if (action.fields == null) return undefined;
  return action.fields.icon;
};
const getIconSvgCode = (action: ScItem<FloatActionWidgetActionFields>) => {
  if (action.fields == null) return '';
  return action.fields.icon?.value?.svgCode || '';
};
const getIconAlt = (action: ScItem<FloatActionWidgetActionFields>) => {
  if (action.fields == null) return '';
  return action.fields.icon?.value?.alt || '';
};
const getAriaLabel = (action: ScItem<FloatActionWidgetActionFields>) => {
  if (action.fields?.link?.value?.text) return action.fields.link.value.text;
  const alt = getIconAlt(action);
  if (alt) return alt;
  return isScrollTop(action) ? 'Back to top' : 'Action';
};
const getVariant = (action: ScItem<FloatActionWidgetActionFields>, index: number) => {
  const variant = getFieldValue(action, 'variant');
  return variant || defaultVariants[index % defaultVariants.length];
};
const getHref = (action: ScItem<FloatActionWidgetActionFields>) => {
  if (action.fields?.link?.value?.href) return action.fields.link.value.href;
  return '#';
};
const getTarget = (action: ScItem<FloatActionWidgetActionFields>) => {
  if (action.fields?.link?.value?.target) return action.fields.link.value.target;
  return undefined;
};
const getRel = (action: ScItem<FloatActionWidgetActionFields>) =>
  getTarget(action) === '_blank' ? 'noopener noreferrer' : undefined;
const isScrollTop = (action: ScItem<FloatActionWidgetActionFields>) =>
  getFieldValue(action, 'actionType') === 'scrollTop';
const isChatbot = (action: ScItem<FloatActionWidgetActionFields>) =>
  getFieldValue(action, 'actionType') === 'chatbot';
const itemClass = (action: ScItem<FloatActionWidgetActionFields>, index: number) =>
  `c-float-action-widget__item--${getVariant(action, index)}`;
const scrollToTop = () => {
  if (typeof window === 'undefined') return;
  window.scrollTo({ top: 0, behavior: 'smooth' });
};
const handleClick = async () => {
  console.log('点击了 Chatbot 按钮');
  const chatInstance = (window as any).chatInstance;
  if (!chatInstance) {
    console.warn('Chatbot 未初始化完成');
    return;
  }
  try {
    await chatInstance.open();
  } catch (err) {
    console.error('唤起失败:', err);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_SiteImage = _resolveComponent("SiteImage")!

  return (actions.value.length)
    ? (_openBlock(), _createElementBlock("aside", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actions.value, (action, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: action.id || index
          }, [
            (isScrollTop(action))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: _normalizeClass(["c-float-action-widget__item", itemClass(action, index)]),
                  type: "button",
                  "aria-label": getAriaLabel(action),
                  onClick: scrollToTop
                }, [
                  (getIconSvgCode(action))
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "c-float-action-widget__icon",
                        "aria-hidden": "true",
                        innerHTML: getIconSvgCode(action)
                      }, null, 8, _hoisted_3))
                    : (_openBlock(), _createBlock(_component_SiteImage, {
                        key: 1,
                        class: "c-float-action-widget__image",
                        field: getIconField(action)
                      }, null, 8, ["field"]))
                ], 10, _hoisted_2))
              : (isChatbot(action))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["c-float-action-widget__item", [itemClass(action, index), 'c-float-action-widget__item--chatbot']]),
                    rel: getRel(action),
                    "aria-label": getAriaLabel(action),
                    onClick: handleClick
                  }, [
                    (getIconSvgCode(action))
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "c-float-action-widget__icon",
                          "aria-hidden": "true",
                          innerHTML: getIconSvgCode(action)
                        }, null, 8, _hoisted_5))
                      : (_openBlock(), _createBlock(_component_SiteImage, {
                          key: 1,
                          class: "c-float-action-widget__image",
                          field: getIconField(action)
                        }, null, 8, ["field"]))
                  ], 10, _hoisted_4))
                : (_openBlock(), _createElementBlock("a", {
                    key: 2,
                    class: _normalizeClass(["c-float-action-widget__item", itemClass(action, index)]),
                    href: getHref(action),
                    target: getTarget(action),
                    rel: getRel(action),
                    "aria-label": getAriaLabel(action)
                  }, [
                    (getIconSvgCode(action))
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "c-float-action-widget__icon",
                          "aria-hidden": "true",
                          innerHTML: getIconSvgCode(action)
                        }, null, 8, _hoisted_7))
                      : (_openBlock(), _createBlock(_component_SiteImage, {
                          key: 1,
                          class: "c-float-action-widget__image",
                          field: getIconField(action)
                        }, null, 8, ["field"]))
                  ], 10, _hoisted_6))
          ], 64))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})